import gql from 'graphql-tag';

const GET_HASHED_EMAIL_LIST_WITH_COUNT = gql`
  query getHashedEmailListWithCount($orgId: String, $searchTerm: String, $skip: Int, $first: Int) {
    getHashedEmailListWithCount(orgId: $orgId, searchTerm: $searchTerm, skip: $skip, first: $first) {
      hashedEmailList
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        totalPages
        currentPage
      }
    }
  }
`;

export default GET_HASHED_EMAIL_LIST_WITH_COUNT;
